/* unplugin-vue-components disabled */import script from "./ColorSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorSelect.vue?vue&type=script&setup=true&lang=js"

import "./ColorSelect.vue?vue&type=style&index=0&id=31930a4c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31930a4c"]])

export default __exports__